import { Card, CardContent, Chip, Typography } from "@mui/material";
import { useStyle } from "./style";
import { Trans, useTranslation } from "react-i18next";

interface IParams {
    description: string;
    shouldReturnEquipments: boolean;
}

export const CancelAddonStatus = (props: IParams) => {
    const { description, shouldReturnEquipments } = props;
    const { classes } = useStyle({});
    const { t } = useTranslation("addons");

    return (
        <Card className={classes.addonStatusContainer} elevation={0}>
            <CardContent className={classes.addonStatusInnerContainer}>
                <Chip className={classes.addonStatusLabel} label={t("cancelled", { description })} />
                <Typography color="secondary" variant="small">
                    <Trans
                        i18nKey={shouldReturnEquipments ? "returnEquipments" : "noReturnEquipments"}
                        ns="addons"
                        values={{ description }}
                    />
                </Typography>
            </CardContent>
        </Card>
    );
};
